import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useDeviationViewContext } from '../../Context';
import DeviationFullView from '../../DeviationViews/Full';
import AttachmentFullView from '../../DeviationViews/Full/ImageAttachment';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import StageBackground from '../../DeviationBackground/StageBackground';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import StageContainer from '../_partials/StageContainer';
import AdditionalImages from '../_partials/AdditionalImages';
import { useMeasuredStage } from '../hooks/useMeasuredStage';
import StashPaddles from '../_partials/StashPaddles';
import s from './DesktopArtStage.scss';
const ADDITIONAL_IMAGES_STRIP_HEIGHT = 68;
export const DesktopArtStage = ({ deviation, className, isZoomed, onEnterZoomMode = ()=>null, onExitZoomMode = ()=>null })=>{
    const { isFullscreen } = useDeviationViewContext();
    const ref = useRef(null);
    const { contentSize, containerSize } = useMeasuredStage(ref, !isFullscreen);
    const [selectedAdditionalImage, selectAdditionalImage] = useState(null);
    const multi_file_deviation = useFlag('multi_file_deviation');
    const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    const additionalImages = useMemo(()=>{
        var _deviation_extended;
        return (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.additionalMedia;
    }, [
        deviation
    ]);
    const showAdditionalImages = multi_file_deviation && additionalImages && additionalImages.length > 0;
    useEffect(()=>{
        selectAdditionalImage(null);
    }, [
        deviation.deviationId
    ]);
    const contentHeight = get(contentSize, 'height');
    const deviationHeight = showAdditionalImages && contentHeight ? contentHeight - ADDITIONAL_IMAGES_STRIP_HEIGHT : contentHeight;
    return /*#__PURE__*/ React.createElement(StageContainer, {
        className: classnames(s['root'], className, isFullscreen && s['fullscreen'], showAdditionalImages && s['with-additional-images'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content'],
        ref: ref
    }, /*#__PURE__*/ React.createElement(StageBackground, {
        deviation: deviation,
        height: get(containerSize, 'height'),
        width: get(containerSize, 'width')
    }), selectedAdditionalImage ? /*#__PURE__*/ React.createElement(AttachmentFullView, {
        attachment: selectedAdditionalImage,
        height: deviationHeight,
        width: get(contentSize, 'width'),
        isZoomed: isZoomed,
        onEnterZoomMode: onEnterZoomMode,
        onExitZoomMode: onExitZoomMode
    }) : /*#__PURE__*/ React.createElement(DeviationFullView, {
        deviation: deviation,
        height: deviationHeight,
        width: get(contentSize, 'width'),
        isZoomed: isZoomed,
        onEnterZoomMode: onEnterZoomMode,
        onExitZoomMode: onExitZoomMode
    }), deviation.isPublished && /*#__PURE__*/ React.createElement(DuperbrowsePaddles, {
        className: s['duperbrowse']
    }), !deviation.isPublished && /*#__PURE__*/ React.createElement(StashPaddles, null), showAdditionalImages && /*#__PURE__*/ React.createElement(AdditionalImages, {
        className: s['additional-images'],
        deviation: deviation,
        selected: selectedAdditionalImage,
        onSelect: (attachment)=>selectAdditionalImage(attachment)
    }), isSubscriptionPurchaseFTUEBeingShown && /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUE, null)));
};
DesktopArtStage.displayName = 'DesktopArtStage';
export default DesktopArtStage;

//# sourceMappingURL=DesktopArtStage.js.map